/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------

==========================================================================================*/

import Vue from "vue";
import App from "./App.vue";

// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
Vue.use(Vuesax);

// axios
import axios from "./axios.js";
Vue.prototype.$http = axios;

// Theme Configurations
import "../themeConfig.js";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";

import BootstrapVue from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue);

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Feather font icon
require("./assets/css/iconfont.css");

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false;

// Global functions
Vue.mixin({
  methods: {
    alertUser(color, message, time = 2000, icon = "icon-alert-circle") {
      this.$vs.notify({
        title: message,
        text: "",
        color: color,
        iconPack: "feather",
        icon: icon,
        time: time
      });
    },
    getDomain() {
      const domain = this.$route.query.company;
      return typeof domain === 'undefined' ? '' : domain;
    },
    getScopedUser(user) {
      return this.getDomain() + '.' + user;
    },
    getRelativeLink(dst) {
      return dst + '?company=' + this.getDomain();
    },
    getDateString(date = new Date()) {
      let dd = String(date.getDate()).padStart(2, '0');
      let mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
      let yyyy = date.getFullYear();
      let dateString = `${yyyy}-${mm}-${dd}`;
      return dateString;
    },
    showLoadingSpinner() {
      this.$vs.loading();
    },
    hideLoadingSpinner() {
      this.$vs.loading.close();
    },
    async getUserSettings(endPoint,userDetails) {
      const urlWithParams = new URL(
        `${process.env.VUE_APP_BASE_URL}${endPoint}`
      );

      if (!userDetails.settings.userRole.includes('Customer')) {
        urlWithParams.searchParams.append(
          "customerName",
          this.$store.getters.userCustomer
        );
      }
      urlWithParams.searchParams.append("APIKey", process.env.VUE_APP_API_KEY);

      let response = await fetch(urlWithParams.href, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      let json = await response.json();
      this.encounteredErrors(json);
      let settings = json.settings;
      return {
        user: settings.name,
        company: settings.company,
        email: settings.email,
        deliveryAddress: settings.delivery_address,
        deliveryName: settings.contact_name,
        deliveryPhone: settings.contact_phone,
        modifyParts: settings.modify_parts != 0,
        lookupItemPrice: settings.lookup_price == 1,
        checkEnoughStock: settings.check_stock,
        logo: settings.logo_url,
        companyEmail: settings.company_email,
        // 0 is light, 1 is dark
        darkTheme: settings.theme == 1,
        minimumLineValue: settings.minimum_order_line,
        minimumOrderTotal: settings.minimum_order_total,
      }
    },
    async getUserDetails() {
      let endPoint = 'Rest/mySettingsForm';

      const urlCheckPermission = new URL(
        `${process.env.VUE_APP_BASE_URL}${endPoint}`
      );

      urlCheckPermission.searchParams.append("APIKey", process.env.VUE_APP_API_KEY);
      let permissionCheck = await fetch(urlCheckPermission.href, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let userRole = await permissionCheck.json();
      this.$store.commit('UPDATE_USER_ROLE',userRole.settings.userRole);
      this.$store.commit('UPDATE_USER_NAME_DOMAIN',userRole.settings.userName)

      if (userRole.settings.userRole.includes('Customer')) {
        endPoint = "Rest/customerSettings";
      } else if(this.$store.getters.userCustomer !== '') {
        endPoint = "Rest/myCustomersCustomerSettings";
      }

      if(endPoint !== 'Rest/mySettingsForm'){
      let userDetails = await this.getUserSettings(endPoint,userRole);
      this.username = userDetails.user;
      this.email = userDetails.email;
      this.company = userDetails.company;
      this.$root.backupCompany = userDetails.company;
      this.deliveryAddress = userDetails.deliveryAddress;
      this.deliveryName = userDetails.deliveryName;
      this.deliveryPhone = userDetails.deliveryPhone;
      this.modifyParts = userDetails.modifyParts;
      this.lookupItemPrice = userDetails.lookupItemPrice;
      this.checkEnoughStock = userDetails.checkEnoughStock;
      this.logo = userDetails.logo;
      this.companyEmail = userDetails.companyEmail;
      this.darkTheme = userDetails.darkTheme;
      this.minimumLineValue = userDetails.minimumLineValue;
      this.minimumOrderTotal = userDetails.minimumOrderTotal;
      if (this.darkTheme) {
        this.toggleClassInBody('dark');
      } else {
        this.toggleClassInBody('light')
      }
    }else{
      this.logo = JSON.parse(userRole.settings.orderPortal).logo_url;
      this.username = userRole.settings.userName;
    }
    },
    encounteredErrors(responseData) {
      if (responseData.service_status) {
        const SUCCESS = 0;
        const NOT_PERMITTED = 3;
        if (responseData.service_status.status != SUCCESS) {
          this.alertUser('danger', 'Error occured: ' + responseData.service_status.message);
          if (responseData.service_status.status == NOT_PERMITTED) {
            this.$router.push("/?company=" + this.$root.backupCompany).catch(error => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          }
          return true;
        } else {
          return false;
        }
      } else if (responseData.status != 0) {
        this.alertUser('danger', 'Error occured: ' + responseData.message);
        return true;
      } else {
        return false;
      }
    },
    getLogos(companyName) {
      const urlWithParams = new URL(
        process.env.VUE_APP_BASE_URL + "Rest/getLogo"
      );
      urlWithParams.searchParams.append("APIKey", process.env.VUE_APP_API_KEY);
      urlWithParams.searchParams.append("user", companyName);

      fetch(urlWithParams.href, {
        method: "GET",
        mode: "cors",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }).then(response => response.json())
        .then(data => {
          this.logo = data.logo_url;
        });
    },
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
  data: {
    backupCompany: ""
  }
}).$mount("#app");
